import React, { useState, useEffect } from "react";

const BannerWrapper = ({ children, onLoad }) => {
  const [useHighRes, setUseHighRes] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Check network speed and update state accordingly.
  useEffect(() => {
    if (navigator.connection) {
      const connection = navigator.connection;
      if (connection.downlink && connection.downlink > 2) {
        setUseHighRes(true);
      }
    } else {
      // Assume fast connection if navigator.connection isn't available.
      setUseHighRes(true);
    }
  }, []);

  // Unlock the page on low-speed connections after a delay.
  useEffect(() => {
    if (!useHighRes && onLoad) {
      const timer = setTimeout(() => {
        onLoad();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [useHighRes, onLoad]);

  // Callback for when the index 0 image loads on high-speed connections.
  const handleImageLoad = () => {
    if (useHighRes) {
      setImageLoaded(true);
      if (onLoad) {
        onLoad();
      }
    }
    if (!useHighRes) {
      setImageLoaded(true);
      const timer = setTimeout(() => {
        onLoad();
      }, 500);
      return () => clearTimeout(timer);
    }

  };

  // Using the render prop pattern so children can access our state and functions.
  return (
    <>
      {typeof children === "function"
        ? children({ useHighRes, imageLoaded, handleImageLoad })
        : children}
    </>
  );
};

export default BannerWrapper;
